<div class="container">
    <div class="row">
        <div class="col-md-12">
            <p>Logging you out...</p>
        </div>
    </div>
</div>